import {
  createEmailThread,
  EmailCreationPopUp,
  isDirtyEmailCreationForm,
  useMassMailingAsyncAction,
} from '../../Email'

import { EPOST_SUPPORT_MODAL_SOURCE_ID } from './EpostContactSupportEmailModal.constants'

function EpostContactSupportEmailModal({ initialValues, onClose }) {
  const {
    checkAsyncMassMailingTaskStatus,
    getAsyncTaskId,
    handleAddFinishMassMailingNotification,
  } = useMassMailingAsyncAction({ onCloseModal: onClose })

  function handleSuccess(data) {
    const asyncTask = getAsyncTaskId(data.data)

    if (asyncTask) {
      checkAsyncMassMailingTaskStatus(
        { ...data, task: asyncTask },
        handleAddFinishMassMailingNotification
      )

      return
    }

    handleAddFinishMassMailingNotification(data)
  }

  return (
    <EmailCreationPopUp
      getIsDirty={isDirtyEmailCreationForm}
      initialValues={initialValues}
      minimizedModalSourceId={EPOST_SUPPORT_MODAL_SOURCE_ID}
      onClose={onClose}
      onSubmit={createEmailThread}
      onSuccess={handleSuccess}
    />
  )
}

export default EpostContactSupportEmailModal
